<template>
  <div>
    <filter-bar
      name="reports"
      :filter="_getReportsFilter"
      v-if="!showMobileView"
      :searchTypes="searchTypes"
    />
    <div style="background: #efefef">
      <v-tabs
        center-active
        :class="tabClass"
        color="black"
        style="background: #efefef"
        :height="tabHeight"
        v-model="tab"
      >
        <div
          class="d-flex justify-space-around"
          style="width: 100%"
          v-if="showMobileView"
        >
          <v-tab class="text-capitalize" id="cam-tab"> Cam </v-tab>
          <v-tab class="text-capitalize" id="rounds-tab"> Rounds </v-tab>
          <v-tab class="text-capitalize" id="golf-tab"> Golf Car </v-tab>
          <v-tab class="text-capitalize" id="course-tab"> Courses </v-tab>
        </div>
        <div
          class="d-flex justify-space-between align-end mb-3 flex-column elevation-4"
          style="width: 100%; height: 100%"
          v-if="!showMobileView"
        >
          <div class="d-flex justify-center" style="width: 100%">
            <div
              class="d-flex justify-center"
              v-if="!showMobileView"
              style="height: 50px; width: 100%"
            >
              <v-tab
                v-if="_client.client_name === 'shark'"
                class="text-capitalize"
                id="reports-cam-tab"
              >
                Cam
              </v-tab>
              <v-tab class="text-capitalize" id="reports-rounds-tab">
                Rounds
              </v-tab>
              <v-tab class="text-capitalize" id="reports-golf-tab">
                Golf Car
              </v-tab>
              <v-tab class="text-capitalize" id="reports-groups-tab">
                Courses
              </v-tab>
            </div>
            <div class="d-flex align-end mt-4">
              <v-card
                class="mr-4 mt-4 mb-1 d-flex align-center"
                height="40"
                width="148"
                color="secondary"
                v-if="!showMobileView && this.tab != 0"
                style="
                  color: white;
                  font-weight: bold;
                  position: absolute;
                  right: 0;
                "
                @click="setDownload()"
              >
                <v-row>
                  <v-spacer />
                  <v-spacer />
                  <v-row
                    class="d-flex justify-space-around"
                    id="reports-export-button"
                  >
                    <v-icon color="white">mdi-download</v-icon>
                    Export Report
                  </v-row>
                  <v-spacer />
                  <v-spacer />
                </v-row>
              </v-card>
              <div
                v-if="tab === 0 && _client.client_name === 'shark'"
                style="position:absolute;right:0;"
              >
                <PDFDownload
                  :_roundsPlayed="_roundsPlayedChart"
                  :_dynamicYardageChart="_dynamicYardageChart"
                  :_scorecardChart="_scorecardChart"
                  :_foodAndBeverageChart="_foodAndBeverageChart"
                  :_listenChart="_listenChart"
                  :_watchChart="_watchChart"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- CAM Report -->
        <v-tab-item :class="tabAdjust" style="background: #efefef">
          <div
            class="d-flex mb-n6 justify-space-between background: #EFEFEF;"
            v-if="showMobileView"
          >
            <search class="ml-3" />
            <v-card
              class="mr-4 mt-6 d-flex align-center flex-shrink-0"
              height="40"
              width="40"
              color="black"
              @click="_setFilter(true)"
            >
              <v-row>
                <v-spacer />
                <v-col>
                  <v-icon color="white">mdi-filter</v-icon>
                </v-col>
                <v-spacer />
              </v-row>
            </v-card>
            <PDFDownload
              :_roundsPlayed="_roundsPlayedChart"
              :_dynamicYardageChart="_dynamicYardageChart"
              :_scorecardChart="_scorecardChart"
              :_foodAndBeverageChart="_foodAndBeverageChart"
              :_listenChart="_listenChart"
              :_watchChart="_watchChart"
            />
          </div>
          <v-row
            class="d-flex flex-wrap justify-space-between mr-3 mt-5 ml-3 mb-3"
          >
            <chart
              type="line-chart"
              :data="_roundsPlayedChart.data"
              :labels="_roundsPlayedChart.labels"
              id="total-rounds-played-chart"
              title="Total Rounds Played"
              :width="graphWidth('100%')"
              :loading="_loadingStates.roundsPlayed"
            />
            <chart
              type="gauge"
              :data="_dynamicYardageChart.data"
              id="dynamic-yardage"
              title="Dynamic Yardages"
              :labels="['Dynamic Yardage']"
              uptime="30 Days"
              :width="graphWidth('30%')"
              :total="_dynamicYardageChart.total"
              :raw="_dynamicYardageChart.raw"
              :loading="_loadingStates.dynamicYardage"
            />
            <chart
              type="gauge"
              id="food-beverage"
              :data="[_foodAndBeverageChart]"
              :labels="['Food and Beverage']"
              title="Food and Beverage"
              :width="graphWidth('30%')"
              :loading="_loadingStates.foodAndBeverage"
            />
            <chart
              type="pie"
              :data="_scorecardChart"
              id="scorecard"
              :labels="['ScoreCard Used', 'ScoreCard Not Used']"
              title="Scorecard"
              :width="graphWidth('30%')"
              total="6939"
              raw="3152"
              :loading="_loadingStates.scorecard"
            />
            <v-card
              class="d-flex flex-column ma-3"
              style="overflow: hidden"
              width="100%"
              v-if="!showMobileView"
            >
              <v-card-title id="listen">Listen</v-card-title>
              <div
                :class="graphClass"
                style="width: 100%; min-height: 100%"
                v-if="!_loadingStates.listen"
              >
                <div
                  class="d-flex flex-column mt-12 ml-10"
                  style="min-width: 5%; max-width: 5%; min-height: 100%"
                >
                  <v-img
                    contain
                    id="tune-in"
                    src="../assets/tuneinlogo.png"
                    style="max-width: 85px; max-height: 85px"
                  ></v-img>
                  <v-img
                    contain
                    id="bluetooth"
                    src="../assets/bluetooth.png"
                    style="max-width: 85px; max-height: 85px"
                  ></v-img>
                  <v-img
                    contain
                    id="audacy"
                    src="../assets/audacy_logo_stacked.png"
                    style="max-width: 85px; max-height: 85px"
                  ></v-img>
                </div>
                <div style="min-width: 95%">
                  <chart
                    type="bar-chart"
                    id="listen-chart"
                    :flat="true"
                    :data="_listenChart.data"
                    :labels="_listenChart.labels"
                    width="100%"
                    :horizontal="true"
                    height="300"
                    :loading="_loadingStates.listen"
                  />
                </div>
              </div>
            </v-card>
            <v-card
              class="d-flex flex-column ma-3"
              style="width: 100%; overflow: hidden"
              v-if="tab === 0 && !showMobileView"
            >
              <v-card-title id="watch">Watch</v-card-title>
              <div :class="graphClass">
                <div
                  class="d-flex flex-column mt-15 ml-10"
                  style="min-width: 5%; max-width: 5%"
                  v-if="!_loadingStates.watch"
                >
                  <v-img
                    contain
                    id="pga"
                    src="../assets/pga.png"
                    style="max-width: 90px; max-height: 90px"
                  ></v-img>
                  <v-img
                    contain
                    id="shark"
                    src="../assets/shark.png"
                    style="max-width: 90px; max-height: 90px"
                  ></v-img>
                  <v-img
                    contain
                    id="atmosphere"
                    src="../assets/atmosphere.png"
                    style="max-width: 90px; max-height: 90px"
                  ></v-img>
                  <v-img
                    contain
                    id="yahoo"
                    src="../assets/yahoosports.png"
                    style="max-width: 90px; max-height: 90px"
                  ></v-img>
                  <v-img
                    contain
                    id="yahoo-news"
                    src="../assets/yahoonews.png"
                    style="max-width: 90px; max-height: 90px"
                  ></v-img>
                </div>
                <div style="min-width: 95%">
                  <chart
                    type="bar-chart"
                    id="watch-chart"
                    :flat="true"
                    :data="_watchChart.data"
                    :labels="_watchChart.labels"
                    width="100%"
                    :horizontal="true"
                    height="500"
                    :loading="_loadingStates.watch"
                  />
                </div>
              </div>
            </v-card>
          </v-row>
        </v-tab-item>
        <!-- Rounds -->
        <v-tab-item :class="tabAdjust" style="background: #efefef">
          <div class="d-flex mb-n6 justify-space-between" v-if="showMobileView">
            <search class="ml-3" />
            <v-card
              class="mr-4 mt-6 d-flex align-center flex-shrink-0"
              height="40"
              width="40"
              color="black"
              @click="_setFilter(true)"
            >
              <v-row>
                <v-spacer />
                <v-col>
                  <v-icon color="white">mdi-filter</v-icon>
                </v-col>
                <v-spacer />
              </v-row>
            </v-card>
          </div>
          <div class="d-flex justify-center pt-5" v-if="showMobileView">
            <v-btn
              style="width: calc(80vw - 32px)"
              @click="setDownload"
              color="secondary"
              height="44"
            >
              <v-icon>mdi-download</v-icon>
              Export Report
            </v-btn>
          </div>
          <div v-if="!showMobileView" class="d-flex justify-center">
            <chart
              type="line-chart"
              :data="_roundsPlayedChart.data"
              :labels="_roundsPlayedChart.labels"
              id="total-rounds-played-chart"
              title="Rounds Played"
              width="45%"
              :loading="_loadingStates.roundsPlayed"
            />
            <chart
              type="bar-chart"
              :data="_launchModesChart.data"
              :labels="_launchModesChart.labels"
              id="launch-chart"
              title="Rounds Report by Model"
              width="45%"
              :options="_launchModesChart.options"
              :loading="_loadingStates.launchMode"
            />
          </div>
          <div
            v-else-if="showMobileView"
            class="d-flex justify-center flex-column"
          >
            <chart
              type="line-chart"
              :data="_roundsPlayedChart.data"
              :labels="_roundsPlayedChart.labels"
              id="total-rounds-played-chart"
              title="Rounds Played"
              width="95%"
              :loading="_loadingStates.roundsPlayed"
            />
            <chart
              type="bar-chart"
              :data="_launchModesChart.data"
              :labels="_launchModesChart.labels"
              :options="_launchModesChart.options"
              id="launch-chart"
              title="Rounds Report by Model"
              width="95%"
              :loading="_loadingStates.launchMode"
            />
          </div>

          <shark-rounds-table v-bind:roundsData="_getRawRounds" class="mt-6" />
        </v-tab-item>
        <!-- Golf Car -->
        <v-tab-item :class="tabAdjust" style="background: #efefef">
          <div class="d-flex mb-n6 justify-space-between" v-if="showMobileView">
            <search class="ml-3" />
            <v-card
              class="mr-4 mt-6 d-flex align-center flex-shrink-0"
              height="40"
              width="40"
              color="black"
              @click="_setFilter(true)"
            >
              <v-row>
                <v-spacer />
                <v-col>
                  <v-icon color="white">mdi-filter</v-icon>
                </v-col>
                <v-spacer />
              </v-row>
            </v-card>
          </div>
          <div class="d-flex justify-center pt-5" v-if="showMobileView">
            <v-btn
              style="width: calc(80vw - 32px)"
              @click="setDownload"
              color="secondary"
              height="44"
            >
              <v-icon>mdi-download</v-icon>
              Export Report
            </v-btn>
          </div>
          <div v-if="!showMobileView" class="d-flex justify-center">
            <chart
              type="line-chart"
              :data="_totalCarsGraph.data"
              :labels="_totalCarsGraph.labels"
              :loading="_loadingStates.totalCars"
              id="total-golf-car-charts"
              title="Total Active Golf Cars"
              width="45%"
            />
            <chart
              type="bar-chart"
              :data="_carsByModelGraph"
              :labels="labels"
              :loading="_loadingStates.carsByModel"
              id="launch-chart"
              title="Golf Car Report by Model"
              :options="_launchModesChart.options"
              width="45%"
            />
          </div>
          <div
            v-else-if="showMobileView"
            class="d-flex justify-center flex-column"
          >
            <chart
              type="line-chart"
              :data="_totalCarsGraph.data"
              :labels="_totalCarsGraph.labels"
              id="total-golf-car-charts"
              :loading="_loadingStates.totalCars"
              title="Total Active Golf Cars"
              width="95%"
            />
            <chart
              type="bar-chart"
              :data="_carsByModelGraph"
              :labels="labels"
              :loading="_loadingStates.carsByModel"
              :options="_launchModesChart.options"
              id="launch-chart"
              title="Golf Car Report by Model"
              width="95%"
            />
          </div>
          <shark-car-table
            v-bind:golfCarData="_dataSearchReducer.sharkScreens.rawData"
            class="mt-6"
          />
        </v-tab-item>
        <!-- Utilization -->
        <v-tab-item :class="tabAdjust" style="background: #efefef">
          <div class="d-flex mb-n6 justify-space-between" v-if="showMobileView">
            <search class="ml-3" />
            <v-card
              class="mr-4 mt-6 d-flex align-center flex-shrink-0"
              height="40"
              width="40"
              color="black"
              @click="_setFilter(true)"
            >
              <v-row>
                <v-spacer />
                <v-col>
                  <v-icon color="white">mdi-filter</v-icon>
                </v-col>
                <v-spacer />
              </v-row>
            </v-card>
          </div>
          <div class="d-flex justify-center pt-5" v-if="showMobileView">
            <v-btn
              style="width: calc(80vw - 32px)"
              color="secondary"
              height="44"
              @click="setDownload"
            >
              <v-icon>mdi-download</v-icon>
              Export Report
            </v-btn>
          </div>
          <div v-if="!showMobileView" class="d-flex justify-center">
            <chart
              type="line-chart"
              :data="_totalGroupsGraph.data"
              :labels="_totalGroupsGraph.labels"
              id="groups-chart"
              :loading="_loadingStates.totalGroups"
              title="Total Active Golf Courses"
              width="45%"
            />
            <chart
              type="bar-chart"
              :data="_groupsByModelGraph"
              :labels="labels"
              title="Course Report by Model"
              width="45%"
              :loading="_loadingStates.groupsByModel"
              :options="_launchModesChart.options"
            />
          </div>
          <div
            v-else-if="showMobileView"
            class="d-flex justify-center flex-column"
          >
            <chart
              type="line-chart"
              :data="_dataSearchReducer.getSharkGroupsChart.data"
              :labels="_dataSearchReducer.getSharkGroupsChart.labels"
              title="Total Active Golf Courses"
              width="95%"
            />
            <chart
              type="bar-chart"
              :data="_dataSearchReducer.groupsLaunchChart.data"
              :labels="_dataSearchReducer.groupsLaunchChart.labels"
              :options="_launchModesChart.options"
              title="Course Report by Model"
              width="95%"
            />
          </div>
          <shark-groups-table
            v-bind:sharkGroupData="_dataSearchReducer.sharkGroups.rawGroupsData"
          />
        </v-tab-item>
      </v-tabs>
    </div>
    <filters />
    <!-- <rental-details /> -->
    <export-shark-reports :tab="tab" />
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import Search from '@/components/app/Search';
import Chart from '@/components/charts/Chart';
import Filters from '@/components/filter/Filters';
import SharkCarTable from '@/components/reports/SharkCarTable';
import SharkRoundsTable from '@/components/reports/SharkRoundsTable';
import SharkGroupsTable from '@/components/reports/SharkGroupsTable';
import FilterBar from '@/components/app/FilterBar';
import ExportSharkReports from '@/components/reports/ExportSharkReports';
import { MobileView } from '@/mixins';
import PDFDownload from '@/components/reports/PDFDownload.vue';
import { sharkReportsDataBuilder } from '@/_store/modules/reports/helpers';

export default {
  components: {
    Search,
    Filters,
    Chart,
    SharkCarTable,
    SharkRoundsTable,
    SharkGroupsTable,
    FilterBar,
    ExportSharkReports,
    PDFDownload,
  },
  data() {
    return {
      currentPage: 1,
      roundsData: 'my header',
      labels: ['Prime', 'Select++', 'Select+', 'Select', 'Bluetooth', 'None'],
    };
  },
  mixins: [MobileView],
  computed: {
    ...mapGetters({
      _sharkChartData: 'reports/getChartData',
      _getReportsFilter: 'filters/getFilter',
      _getExport: 'reports/getExport',
      _getTab: 'reports/getTab',
      _client: 'account/getCurrentClient',

      _roundsPlayedChart: 'reports/getRoundsPlayedChart',
      _launchModesChart: 'reports/getLaunchModesChart',
      _totalCarsGraph: 'reports/getTotalCarsGraph',
      _carsByModelGraph: 'reports/getCarsByModelGraph',
      _totalGroupsGraph: 'reports/getTotalGroupsGraph',
      _groupsByModelGraph: 'reports/getGroupsByModelGraph',
      _sharkAnalytics: 'reports/getSharkAnalytics',
      _rounds: 'reports/getRounds',
      _dynamicYardageChart: 'reports/getDynamicYardageChart',
      _scorecardChart: 'reports/getScorecardChart',
      _foodAndBeverageChart: 'reports/getFoodAndBeverageChart',
      _listenChart: 'reports/getListenChart',
      _watchChart: 'reports/getWatchChart',
      _loadingStates: 'reports/getGraphLoadingStates',

      sharkReportsDataModel: 'reports/getSharkReportsDataModel',
    }),
    _getRawRounds() {
      if (this._rounds.slice) {
        return this._rounds.slice(0, this._rounds.length);
      }
      return 0;
    },
    _dataSearchReducer() {
      const sharkReports = this.sharkReportsDataModel;

      const { rounds, screens, groups } = sharkReportsDataBuilder(sharkReports);
      if (rounds && screens && groups) {
        sharkReports.roundsLaunchChart.data = rounds.data;
        sharkReports.roundsPlayedChart = rounds.chart;
        sharkReports.cartsLaunchChart.data = screens.data;
        sharkReports.getGolfCarChart = screens.chart;
        sharkReports.getSharkGroupsChart = groups.chart;
        sharkReports.groupsLaunchChart.data = groups.data;
        return sharkReports;
      }
      return sharkReports;
    },
    tab: {
      get() {
        return this._getTab;
      },
      set(val) {
        this._setTab(val);
      },
    },
    searchTypes() {
      return ['Course Name', 'Cart ID'];
    },
    oneWayTerm() {
      return 'Bluetooth';
    },
    roundTripTerm() {
      return 'Premium';
    },
    graphTitle() {
      return 'BlueTooth vs Premium';
    },
    tabHeight() {
      if (this.showMobileView) {
        return '28px';
      }
      return '50px';
    },
    tabClass() {
      if (this.showMobileView) {
        return 'mt-4';
      }
      return '';
    },
    tabAdjust() {
      if (this.showMobileView) {
        return '';
      }
      return '';
    },
    chartWidth() {
      if (this.showMobileView) {
        return '100%';
      }
      return '30%';
    },
    convertedFilter() {
      const filterArray = [];
      const newFilter = { ...this._getReportsFilter };
      Object.keys(newFilter).forEach((key) => {
        if (
          this._getReportsFilter.range &&
          key !== 'start_date' &&
          key !== 'end_date'
        ) {
          const filterObject = {
            value: this._getReportsFilter[key],
            name: key,
          };
          filterArray.push(filterObject);
        }
      });
      return filterArray;
    },
    graphClass() {
      if (this.showMobileView) {
        return 'd-flex flex-column';
      }
      return 'd-flex';
    },
    graphHeight() {
      if (this.showMobileView) {
        return '33%';
      }
      return '100%';
    },
  },
  methods: {
    ...mapActions({
      _acquireData: 'reports/acquireGroups',
      _acquireInstances: 'reports/acquireSessions',
    }),
    ...mapMutations({
      _setFilter: 'filters/setFilters',
      setReportsFilter: 'filters/setReportsFilter',
      _setExport: 'reports/setExport',
      _setTab: 'reports/setTab',
    }),
    adjustReportsFilter(item) {
      if (item === 'clear') {
        this.setReportsFilter({
          search: '',
        });
      } else {
        const copiedFilter = { ...this.getReconciliationFilter };
        delete copiedFilter[item.name];
        if (item.name === 'range') {
          delete copiedFilter.start_date;
          delete copiedFilter.end_date;
        }
        this.setReportsFilter(copiedFilter);
      }
    },
    graphWidth(width) {
      if (width && !this.showMobileView) {
        return width;
      }
      if (this.showMobileView) {
        return '100%';
      }
      return '47%';
    },
    getChartPercentage(value, sessions) {
      return ((100 * value) / sessions.length).toFixed(1);
    },
    setDownload() {
      this._setExport(true);
    },
  },
  watch: {
    tab() {
      window.dispatchEvent(new Event('resize'));
    },
  },
};
</script>
